import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'

export default {
    name: 'EditPublisher',
    components: {
        ManageAuthor: () => import(/* webpackChunkName: "publisher" */ '../../Author/ManageAuthor/ManageAuthor.vue'),
        EditAuthorForm: () => import(/* webpackChunkName: "publisher" */ '@/components/pages/Card/Author/EditAuthorForm/EditAuthorForm.vue')
    },
    beforeMount(){
        this.claimTo = cloneDeep(this.$store.getters.getInformationToEdit)
        if(isEmpty(this.$store.getters.getInformationToEdit)){
            this.$router.push('card')
        }
    },
    data(){
        return{
            claimTo: {}
        }
    },
    methods:{
        setClaimTo(claimTo){
            this.claimTo = claimTo
        }
    }
}